import type { ButtonHTMLAttributes, ReactNode } from "react";

import { cn } from "../lib/utils";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "ghost" | "secondary";
  children: ReactNode;
}

export function Button({ variant = "primary", className, children, ...rest }: ButtonProps) {
  const base =
    "inline-flex items-center justify-center font-display font-semibold rounded-lg px-5 py-2.5 text-sm tracking-tight transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    // Solid pickleball-yellow — the main CTA across the app
    primary:
      "bg-accent text-ink hover:bg-accent-soft hover:-translate-y-px disabled:hover:translate-y-0",
    // Subtle outline — for secondary actions
    secondary:
      "bg-bg-2 text-paper border border-line hover:border-accent/40 hover:bg-bg-3",
    // Mono terminal style — for "sign out" / quiet actions
    ghost:
      "bg-transparent text-paper-muted font-mono text-xs uppercase tracking-wider px-3 hover:text-paper",
  } as const;
  return (
    <button className={cn(base, variants[variant], className)} {...rest}>
      {children}
    </button>
  );
}
